import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import CommonAccountContMain from "presentation/view/container/CommonAccount/CommonAccountContMain";

CommonEntrypoint(<CommonAccountContMain/>)